<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center justify-space-between" xs12 mt-3>
          <h1 class="headline">{{ $t('workersList.title') }}</h1>
          <div class="d-flex align-center">
            <v-btn class="mr-3" icon @click="settingsDialog = true">
              <v-icon>
                mdi-cog
              </v-icon>
            </v-btn>
            <export-button
              v-if="$can('workdesk_excel_export')"
              class="mr-2"
              action-name="workers-board/downloadReport"
              large
              :file-name="$t('workersList.title')"
              :disabled="dataLoading"
              :query="{ ...filters, dates }"
            />
            <v-btn
              v-if="
                $can('workdesk_add') &&
                  $can('workdesk_edit_driver_and_auto_status')
              "
              color="warning"
              class="mr-2"
              large
              depressed
              :disabled="dataLoading"
              @click="dialog = true"
            >
              {{ $t('common.button.add') }}
            </v-btn>
            <v-btn
              v-if="$can('workdesk_view_history')"
              class="mr-2"
              elevation="0"
              color="info"
              :to="{ path: 'history', query: { dates } }"
              large
            >
              {{ $t('workersList.history') }}
            </v-btn>
            <v-btn
              v-if="$can('workdesk_view_statistic')"
              elevation="0"
              color="blue-grey white--text"
              :to="{ path: 'statistics' }"
              large
            >
              {{ $t('workersStatistics.title') }}
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm12 mt-4>
          <v-layout wrap align-center>
            <v-flex xs12 sm12 mt-4 mb-3>
              <div class="d-flex search-wrapper">
                <div class="search d-flex">
                  <v-text-field
                    ref="search"
                    v-model="searchString"
                    :placeholder="$t('rentsList.search.placeholder')"
                    autocomplete="off"
                    solo
                    hide-details
                  />
                  <v-btn
                    type="button"
                    class="search-btn warning"
                    depressed
                    large
                    @click="filters.search = searchString"
                  >
                    {{ $t('common.btns.search') }}
                  </v-btn>
                </div>
                <v-checkbox
                  v-if="isAdmin"
                  v-model="filters.withTrashed"
                  color="warning"
                  style="margin-left:40px;margin-top:10px"
                  true-value="1"
                  false-value="0"
                  :label="$t('common.labels.showDeleted')"
                />
              </div>
            </v-flex>
            <div class="workers-board__filters">
              <v-menu
                ref="menuDate"
                :close-on-content-click="false"
                v-model="menuDate"
                :return-value.sync="dates"
                max-width="280px"
                min-width="280px"
                class="pr-4 mt-2"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="dates"
                    prepend-icon="mdi-calendar"
                    :label="$t('common.fields.rentDate')"
                    readonly
                    class="date workers-board__filters-item"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  color="primary lighten-1"
                  width="280"
                  range
                  :locale="$i18n.locale"
                  :selected-items-text="dates.toString()"
                  :allowed-dates="allowedDates"
                  @input="changeDate"
                ></v-date-picker>
              </v-menu>

              <v-select
                v-model="filters.status"
                :label="$t('common.fields.status')"
                item-text="name"
                item-value="id"
                class="filter workers-board__filters-item"
                clearable
                :items="$store.state['workers-board'].carStatuses"
                :loading="dataLoading"
              ></v-select>

              <v-select
                v-model="filters.payment_type"
                item-text="name"
                item-value="id"
                class="filter workers-board__filters-item"
                clearable
                :label="$t('common.fields.paymentMethod')"
                :items="paymentTypes"
                :loading="dataLoading"
              ></v-select>

              <v-select
                v-if="carParks.length > 1"
                v-model="filters.carParks"
                class="workers-board__filters-item park"
                item-text="name"
                item-value="id"
                :label="$t('employees.park')"
                :items="carParks"
                multiple
              >
              
                <template #selection="{ index }">
                  <template v-if="index > 0"></template>
                  <template v-else>
                    {{ filters.carParks.length }}
                    {{ $t('common.selected') }}
                  </template>
                </template>
              </v-select>
              
              <v-select
                v-model="filters.qty_days"
                class="workers-board__filters-item qty_days"
                item-text="name"
                item-value="id"
                :label="$t('workersList.by_qty_days')"
                :items="byMileage"
              ></v-select>
              
              <v-select
                v-model="filters.mileage"
                class="workers-board__filters-item mileage"
                item-text="name"
                item-value="id"
                :label="$t('workersList.by_mileage')"
                :items="byMileage"
              ></v-select>
              
              <v-text-field
                v-model="expenseSearch"
                class="workers-board__filters-item expense-search"
                :label="$t('workersList.expenceSearch')"
              >
                <template #append>
                  <div class="d-flex mt-1">
                    <v-btn
                      v-if="expenseSearch"
                      class="mr-1"
                      icon
                      x-small
                      @click="
                        () => {
                          expenseSearch = '';
                          filters.expence_comment = '';
                        }
                      "
                    >
                      <v-icon small> mdi-close </v-icon>
                    </v-btn>
                    <v-btn
                      color="warning"
                      elevation="0"
                      rounded
                      x-small
                      @click="filters.expence_comment = expenseSearch"
                    >
                      <v-icon small> mdi-magnify </v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-text-field>

              <v-checkbox
                v-model="noPrepayment"
                :label="$t('workersList.withoutPrepayment')"
                class="mr-4"
                color="warning"
              />

              <v-checkbox
                v-model="filters.is_car_left"
                true-value="1"
                :false-value="null"
                :label="$t('workersStatistics.left')"
                class="mr-4"
                color="warning"
              />

              <v-select
                class="filter workers-board__filters-perPage"
                item-text="name"
                item-value="value"
                :label="$t('common.perPage')"
                :items="[
                  { value: 99999, name: $t('common.allItems') },
                  { value: 100, name: '100' },
                ]"
                :value="perPage"
                @change="filters.pageRows = $event"
              ></v-select>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        class="workers-board"
        ref="workers-table"
        hide-default-header
        hide-default-footer
        :height="tableHeight"
        :headers="filteredHeaders"
        :items="items"
        :loading="loading"
        :items-per-page="perPage"
        :no-data-text="$t('common.table.noData')"
      >
        <template #header>
          <thead class="v-data-table-header">
            <tr>
              <template v-for="(header, key) in filteredHeaders">
                <th
                  v-if="$can(header.permission)"
                  class="text-align-center"
                  :class="{ section: header.sections }"
                  :key="key"
                  :colspan="header.sections ? header.sections.length : 1"
                >
                  {{ header.sections ? $t(header.text) : '' }}
                </th>
              </template>
            </tr>

            <tr>
              <template v-for="(header, key) in filteredHeaders">
                <template v-if="$can(header.permission)">
                  <th v-if="!header.sections" :key="key">
                    {{ $t(header.text) }}
                  </th>

                  <th
                    v-else
                    v-for="item in header.sections"
                    :key="item.text"
                    class="section"
                  >
                    {{ $t(item.text) }}
                  </th>
                </template>
              </template>
            </tr>
          </thead>
        </template>

        <template #item="{ item, index }">
          <tr
            :key="item.id"
            :class="{
              'disabled-row': itemsUpdating.includes(item.id),
              'updated-row': itemsUpdated.includes(item.id),
              'deleted-row': item.deleted_at,
            }"
          >
            <td v-if="role === 'admin'">
              <v-btn
                v-if="item.deleted_at"
                class="restore-btn"
                color="warning"
                small
                icon
                :loading="restoreIds.includes(item.id)"
                @click="
                  () => {
                    confirmDialog.value = true;
                    confirmDialog.title = $t('common.restore') + ' ?';
                    confirmDialog.action = () => restoreItem(item.id);
                  }
                "
              >
                <v-icon small>mdi-restore</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="red"
                small
                icon
                :loading="deletingIds.includes(item.id)"
                @click="
                  () => {
                    confirmDialog.value = true;
                    confirmDialog.title = $t('common.btns.delete');
                    confirmDialog.action = () => deleteItem(item.id);
                  }
                "
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
            <td>{{ item.num }}</td>
            <td>
              <div class="date-td">
                {{ item.created_at || '-' }}
              </div>
            </td>
            <td v-if="!isHidden('investor-name')">
              {{ item.car.investor.user.name || '-' }}
            </td>
            <td>
              <v-btn
                color="warning"
                elevation="0"
                small
                text
                :to="`/autos/${item.car.id}/info`"
              >
                {{ item.car.number || '-' }}
              </v-btn>
            </td>
            <td v-if="!isHidden('auto-brand')">
              {{ item.car.brand.name || '-' }}
            </td>
            <td v-if="!isHidden('auto-model')">
              {{ item.car.model.name || '-' }}
            </td>
            <td v-if="!isHidden('rent-price')">
              {{ item.car.rentDayPrice || '-' }}
            </td>
            <td v-if="!isHidden('auto-park')">
              {{ item.car.park.name || '-' }}
            </td>
            <td v-if="!isHidden('mileage')">
              {{ item.mileage || '-' }}
            </td>
            <td>
              <router-link
                v-if="item.driver"
                class="driver-link"
                :to="`/drivers/${item.driver.id}/info`"
              >
                {{ getDriver(item).user.name }}
              </router-link>
              <span v-else>-</span>
            </td>
            <td v-if="!isHidden('kaspi-number')">
              {{ getDriver(item).kaspi_number || '-' }}
            </td>
            <td v-if="!isHidden('shift')">{{ item.car_shift_name || '-' }}</td>
            <td>
              <button
                v-if="item.car_status === 5"
                class="edit-btn"
                @click="
                  () => {
                    snack.value = true;
                    snack.color = 'warning';
                    snack.message = $t('workersList.rentAutoStatus.attention');
                  }
                "
              >
                {{ getDriver(item).user.phone }}
              </button>

              <edit-on-click-field v-else :label="getDriver(item).user.phone">
                <driver-select
                  permission="workdesk_edit_driver_and_auto_status"
                  :key="getDriver(item).user.phone || Math.random()"
                  :phone="getDriver(item).user.phone"
                  hide-details
                  autofocus
                  @change="
                    updateItem({
                      ...item,
                      ...$event,
                    })
                  "
                />
              </edit-on-click-field>
            </td>
            <td v-if="!isHidden('phone-relative')">
              {{ getDriver(item).phoneRelative || '-' }}
            </td>
            <td class="nowrap" :class="getStatusColor(item.car_status)">
              <edit-on-click-field
                :label="getStatusName(item.car_status, item.qty_days_status)"
                :disabled="
                  !$can('workdesk_edit_on_buyout') && item.car_status === 13
                "
              >
                <status-select
                  :item="item"
                  :days-till-vocation="item.days_till_vocation"
                  autofocus
                  @change="setRating({ ...item, car_status: $event }, item.car_status)"
                />
              </edit-on-click-field>
            </td>
            <td v-if="!isHidden('coming') && $can('workdesk_income')">
              <div class="d-flex align-items-center">
                <v-btn
                  v-if="
                    checkIsTransactionEditable(item.income.deposit.amount, item)
                  "
                  small
                  text
                  :disabled="!$can('workdesk_edit_cash')"
                  @click="
                    incomeEdit = {
                      item,
                      value: true,
                      type: 1,
                      title: $t('common.table.deposit'),
                    }
                  "
                >
                  {{ formatAmount(item.income.deposit.amount) }}
                </v-btn>
                <span v-else>-</span>
                <v-tooltip
                  v-if="item.income.deposit.description"
                  top
                  color="warning"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      color="warning"
                      small
                      v-on="on"
                      v-bind="attrs"
                    >
                      mdi-comment-text-outline
                    </v-icon>
                  </template>
                  <div v-html="item.income.deposit.description" />
                </v-tooltip>
              </div>
            </td>
            <td v-if="!isHidden('coming') && $can('workdesk_income')">
              <div class="d-flex align-items-center">
                <v-btn
                  v-if="
                    checkIsTransactionEditable(
                      item.income.debtRepayment.amount,
                      item,
                    )
                  "
                  small
                  text
                  :disabled="!$can('workdesk_edit_cash')"
                  @click="
                    incomeEdit = {
                      item,
                      value: true,
                      type: 3,
                      title: $t('common.table.returnedDebt'),
                    }
                  "
                >
                  {{ formatAmount(item.income.debtRepayment.amount) }}
                </v-btn>
                <span v-else>-</span>
                <v-tooltip
                  v-if="item.income.debtRepayment.description"
                  top
                  color="warning"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      color="warning"
                      small
                      v-on="on"
                      v-bind="attrs"
                    >
                      mdi-comment-text-outline
                    </v-icon>
                  </template>
                  <div v-html="item.income.debtRepayment.description" />
                </v-tooltip>
              </div>
            </td>
            <td
              v-if="!isHidden('coming') && $can('workdesk_income')"
              :class="getPrepaymentColor(item)"
            >
              <div class="d-flex align-items-center">
                <v-btn
                  v-if="
                    checkIsTransactionEditable(
                      item.income.prepayment.amount,
                      item,
                    )
                  "
                  small
                  text
                  :disabled="!$can('workdesk_edit_cash')"
                  @click="
                    incomeEdit = {
                      item,
                      value: true,
                      type: 2,
                      title: $t('common.table.prepayment'),
                    }
                  "
                >
                  {{ formatAmount(item.income.prepayment.amount) }}
                </v-btn>
                <span v-else>-</span>
                <v-tooltip
                  v-if="item.income.prepayment.description"
                  top
                  color="warning"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      color="warning"
                      small
                      v-on="on"
                      v-bind="attrs"
                    >
                      mdi-comment-text-outline
                    </v-icon>
                  </template>

                  <div v-html="item.income.prepayment.description" />
                </v-tooltip>
              </div>
            </td>
            <td v-if="!isHidden('coming') && $can('workdesk_income')">
              <div class="d-flex align-items-center">
                <v-btn
                  v-if="
                    checkIsTransactionEditable(item.income.damage.amount, item)
                  "
                  small
                  text
                  :disabled="!$can('workdesk_edit_cash')"
                  @click="
                    incomeEdit = {
                      item,
                      value: true,
                      type: 15,
                      title: $t('common.table.damage'),
                    }
                  "
                >
                  {{ formatAmount(item.income.damage.amount) }}
                </v-btn>
                <span v-else>-</span>
                <v-tooltip
                  v-if="item.income.damage.description"
                  top
                  color="warning"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      color="warning"
                      small
                      v-on="on"
                      v-bind="attrs"
                    >
                      mdi-comment-text-outline
                    </v-icon>
                  </template>
                  <div v-html="item.income.damage.description" />
                </v-tooltip>
              </div>
            </td>
            <td
              v-if="
                !isHidden('explanation') && $can('workdesk_view_explanation')
              "
            >
              <div
                class="text-edit-btn"
                :class="{ disabled: !$can('workdesk_edit_explanation') }"
                @click="
                  textFieldDialog = {
                    value: true,
                    label: $t('workersList.explanation'),
                    param: 'explanation',
                    item: item,
                  }
                "
              >
                {{ item.explanation || '-' }}
              </div>
            </td>
            <td v-if="!isHidden('duty') && $can('workdesk_debt')">
              <div class="d-flex align-items-center">
                <v-btn
                  small
                  text
                  :disabled="
                    !item.driver_id ||
                      !item.car_status ||
                      !$can('workdesk_edit_cash')
                  "
                  @click="debtEdit = { value: true, item }"
                >
                  {{ formatAmount(item.driver_debt) }}
                </v-btn>

                <v-tooltip v-if="item.driver_debt_comment" top color="warning">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      color="warning"
                      small
                      v-on="on"
                      v-bind="attrs"
                    >
                      mdi-comment-text-outline
                    </v-icon>
                  </template>
                  {{ item.driver_debt_comment }}
                </v-tooltip>
              </div>
            </td>
            <td v-if="!isHidden('consumption') && $can('workdesk_expense')">
              <div class="d-flex align-items-center">
                <v-btn
                  small
                  text
                  :disabled="isExpenseDisabled(item)"
                  @click="
                    expenseEdit = {
                      item,
                      value: true,
                    }
                  "
                >
                  {{ formatAmount(item.expense_total) }}
                </v-btn>
                <v-tooltip v-if="getExpenses(item.transactions)" top>
                  <template #activator="{ on, attrs }">
                    <v-icon
                      class="ml-2"
                      color="warning"
                      v-on="on"
                      v-bind="attrs"
                      small
                    >
                      mdi-clipboard-text-clock-outline
                    </v-icon>
                  </template>

                  <p class="mb-0" v-html="getExpenses(item.transactions)" />
                </v-tooltip>
              </div>
            </td>
          </tr>

          <tr
            v-if="index === items.length - 1 && !noPrepayment"
            class="workers-board__totals grey lighten-3"
          >
            <td :colspan="totalColspan">
              {{ $t('common.total') }}
            </td>
            <td v-if="$can('workdesk_income') && !isHidden('coming')">
              {{ formatAmount(totals.deposit) }}
            </td>
            <td v-if="$can('workdesk_income') && !isHidden('coming')">
              {{ formatAmount(totals.debtRepayment) }}
            </td>
            <td v-if="$can('workdesk_income') && !isHidden('coming')">
              {{ formatAmount(totals.prepayment) }}
            </td>
            <td v-if="$can('workdesk_income') && !isHidden('coming')">
              {{ formatAmount(totals.damage) }}
            </td>
            <td
              v-if="
                $can('workdesk_view_explanation') && !isHidden('explanation')
              "
            />
            <td v-if="$can('workdesk_debt') && !isHidden('duty')">
              {{ formatAmount(totals.debt) }}
            </td>
            <td v-if="$can('workdesk_expense') && !isHidden('consumption')">
              {{ formatAmount(totals.expense) }}
            </td>
          </tr>
        </template>

        <template #footer>
          <v-divider />
          <div class="pt-1 pb-2">
            <v-pagination
              color="warning"
              :value="currentPage"
              :length="lastPage"
              dark
              circle
              @input="fetchList({ ...filters, dates, page: $event })"
            />
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <confirm-dialog
      v-model="confirmDialog.value"
      :title="confirmDialog.title"
      @confirm="confirmDialog.action"
    />

    <worker-dialog
      v-model="dialog"
      :data="selectedItem"
      @closed="selectedItem = null"
      @success="fetchList({ ...filters, dates, page: currentPage })"
    />

    <settings-dialog
      v-model="settingsDialog"
      :hidden-columns="hiddenColumns"
      @save="hiddenColumns = $event"
    />

    <rating-dialog
      v-model="ratingDialog"
      :driver_id="driverId"
    />

    <income-edit-dialog
      v-model="incomeEdit.value"
      :title="incomeEdit.title"
      :type="incomeEdit.type"
      :item="incomeEdit.item"
      @updated="onItemUpdated"
    />

    <debt-edit-dialog
      v-model="debtEdit.value"
      :item="debtEdit.item"
      @updated="onItemUpdated"
    />

    <expense-edit-dialog
      v-model="expenseEdit.value"
      :item="expenseEdit.item"
      @updated="onItemUpdated"
    />

    <text-field-edit-dialog
      v-model="textFieldDialog.value"
      :param-name="textFieldDialog.param"
      :current-value="textFieldDialog.item[textFieldDialog.param]"
      :label="textFieldDialog.label"
      @save="updateItem({ ...textFieldDialog.item, ...$event })"
    />

    <v-snackbar v-model="snack.value" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import StatusSelect from '@/components/workers-board/StatusSelect.vue';
import DriverSelect from '@/components/shared/DriverSelect.vue';
import SettingsDialog from '@/components/workers-board/SettingsDialog.vue';
import ExportButton from '@/components/shared/ExportButton.vue';
import IncomeEditDialog from '@/components/workers-board/IncomeEditDialog.vue';
import DebtEditDialog from '@/components/workers-board/DebtEditDialog.vue';
import ExpenseEditDialog from '@/components/workers-board/ExpenseEditDialog.vue';
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue';
import TextFieldEditDialog from '@/components/shared/TextFieldEditDialog.vue';
import formatAmount from '@/helpers/formatAmount';
import calcTableHeight from '@/helpers/calcTableHeight';
import EditOnClickField from '@/components/shared/EditOnClickField.vue';
import WorkerDialog from './WorkerDialog.vue';
import RatingDialog from '@/components/workers-board/RatingDialog.vue';

export default {
  components: {
    WorkerDialog,
    StatusSelect,
    DriverSelect,
    SettingsDialog,
    ExportButton,
    IncomeEditDialog,
    DebtEditDialog,
    ExpenseEditDialog,
    ConfirmDialog,
    TextFieldEditDialog,
    EditOnClickField,
    RatingDialog,
  },
  data: () => ({
    loading: true,
    dataLoading: true,
    dialog: false,
    tableHeight: 'auto',
    hiddenColumns: [],
    settingsDialog: false,
    ratingDialog: false,
    selectedItem: null,
    deletingIds: [],
    restoreIds: [],
    menuDate: false,
    itemsUpdating: [],
    itemsUpdated: [],
    dates: [],
    confirmDialog: {
      value: false,
      title: null,
      action: () => {},
    },

    searchString: '',
    expenseSearch: '',
    noPrepayment: false,

    filters: {
      search: '',
      status: '',
      pageRows: null,
      payment_type: '',
      withTrashed: 0,
      expence_comment: '',
      carParks: [],
      is_car_left: null,
      mileage: '',
      qty_days: '',
    },

    incomeEdit: {
      value: false,
      type: 0,
      title: '',
      item: {},
    },

    debtEdit: {
      value: false,
      item: {},
    },

    expenseEdit: {
      value: false,
      item: {},
    },

    textFieldDialog: {
      value: false,
      item: {},
      param: '',
      label: '',
    },

    snack: {
      value: false,
      message: '',
      color: '',
    },
    driverId: 0,
  }),
  watch: {
    dates(value) {
      if (value.length === 1) return false;
      this.fetchList({ ...this.filters, dates: this.dates, page: 1 });
      return null;
    },
    filters: {
      deep: true,
      handler(data) {
        this.fetchList({ ...data, dates: this.dates, page: 1 });
      },
    },
    noPrepayment(val) {
      if (val && this.filters.pageRows === 99999) {
        this.fetchList({ ...this.filters, dates: this.dates, page: 1 });
      } else if (!val && this.filters.pageRows === 100) {
        this.fetchList({ ...this.filters, dates: this.dates, page: 1 });
      } else if (val) {
        this.filters.pageRows = 99999;
      } else {
        this.filters.pageRows = 100;
      }
    },
  },
  computed: {
    ...mapState({
      list: (state) => state['workers-board'].list,
      currentPage: (state) => state['workers-board'].currentPage,
      lastPage: (state) => state['workers-board'].lastPage,
      perPage: (state) => state['workers-board'].perPage,
      expensesTypes: (state) => state['workers-board'].expensesTypes,
      paymentTypes: (state) => state['workers-board'].paymentTypes,
      carStatuses: (state) => state['workers-board'].carStatuses,
    }),
    role() {
      return this.$store.getters['global/getRole'];
    },
    filteredHeaders() {
      return this.headers.reduce((res, item) => {
        const header = JSON.parse(JSON.stringify(item));

        if (this.isHidden(header.key)) return res;

        res.push(header);

        if (header.sections) {
          header.sections = header.sections.filter(
            (section) => !this.isHidden(section.key),
          );
        }

        return res;
      }, []);
    },
    headers() {
      const headers = [
        { text: 'common.number' },
        { text: 'common.fields.bookingDate' },
        { text: 'workersList.investorFullName', key: 'investor-name' },
        {
          text: 'common.fields.selectAuto',
          sections: [
            { text: 'auto.fields.number' },
            { text: 'auto.fields.brand', key: 'auto-brand' },
            { text: 'auto.fields.model', key: 'auto-model' },
            { text: 'workersList.rentPrice', key: 'rent-price' },
            { text: 'auto.fields.park', key: 'auto-park' },
            { text: 'auto.fields.mileage_for_day', key: 'mileage' },
          ],
        },
        { text: 'autoRents.tableHeaders.name' },
        { text: 'driverAdd.kaspi', key: 'kaspi-number' },
        { text: 'workersList.shift', key: 'shift' },
        { text: 'notification.phone.label' },
        { text: 'common.fields.phoneRelative', key: 'phone-relative' },
        { text: 'common.fields.status' },
        {
          text: 'common.table.coming',
          key: 'coming',
          permission: 'workdesk_income',
          sections: [
            { text: 'common.table.deposit' },
            { text: 'common.table.returnedDebt' },
            { text: 'common.table.prepayment' },
            { text: 'common.table.damage' },
          ],
        },
        {
          text: 'workersList.explanation',
          key: 'explanation',
          permission: 'workdesk_view_explanation',
        },
        { text: 'common.table.duty', key: 'duty', permission: 'workdesk_debt' },
        {
          text: 'common.table.consumption',
          key: 'consumption',
          permission: 'workdesk_expense',
        },
      ];

      if (this.role === 'admin') {
        headers.unshift({ text: '' });
      }

      return headers;
    },
    items() {
      return this.list.map((item) => {
        const income = item.transactions.filter((tr) => tr.is_number_positive);

        /* eslint-disable */

        const collectByType = (type) => {
          return income.reduce(
            (res, data) => {
              if (data.type !== type) return res;

              if (!res.amount) res.amount = 0;

              res.amount = Number(res.amount) + Number(data.amount);
              res.description += `
              <div>
                ${this.$t('common.fields.sum')}: ${formatAmount(data.amount)}
              </div>
              <div>
                ${this.$t('common.fields.paymentMethod')}:
                ${data.payment_type_name}
              </div>
              <div class="mb-2">
                ${this.$t('common.fields.comment')}: ${data.comment || '-'}
              </div>
            `;

              return res;
            },
            { amount: undefined, description: '' },
          );
        };

        /* eslint-enable */

        return {
          ...item,
          income: {
            deposit: collectByType(1),
            prepayment: collectByType(2),
            debtRepayment: collectByType(3),
            damage: collectByType(15),
          },
        };
      });
    },
    today() {
      const date = new Date();
      const formatNum = (v) => (v < 10 ? `0${v}` : v);
      return `${date.getFullYear()}-${formatNum(
        date.getMonth() + 1,
      )}-${date.getDate()}`;
    },
    totals() {
      const initialValues = {
        deposit: 0,
        debt: 0,
        expense: 0,
        prepayment: 0,
        debtRepayment: 0,
        damage: 0,
      };

      return this.items.reduce((res, item) => {
        const itemDeposit = Number(item.income.deposit.amount) || 0;
        const itemDebt = Number(item.driver_debt) || 0;
        const itemExpense = Number(item.expense_total) || 0;
        const itemPrepayment = Number(item.income.prepayment.amount) || 0;
        const itemDebtRepayment = Number(item.income.debtRepayment.amount) || 0;
        const itemDamage = Number(item.income.damage.amount) || 0;

        return {
          deposit: res.deposit + itemDeposit,
          debt: res.debt + itemDebt,
          expense: res.expense + itemExpense,
          prepayment: res.prepayment + itemPrepayment,
          debtRepayment: res.debtRepayment + itemDebtRepayment,
          damage: res.damage + itemDamage,
        };
      }, initialValues);
    },
    /* eslint-disable */
    totalColspan() {
      let colspan = this.role === 'admin' ? 14 : 13;

      this.hiddenColumns.forEach((item) => {
        switch (item) {
          case 'investor-name':
          case 'auto-brand':
          case 'auto-model':
          case 'rent-price':
          case 'auto-park':
          case 'mileage':
          case 'kaspi-number':
          case 'shift':
          case 'phone-relative':
            colspan--;
        }
      });

      return colspan;
    },
    isAdmin() {
      return this.$store.getters['global/getRole'] === 'admin';
    },
    carParks() {
      return JSON.parse(localStorage.getItem('me')).parks;
    },
    byMileage() {
      return [{id: 1, 'name': 'По убыванию'}, {id: 2, 'name': 'По возрастанию'}];
    },
    /* eslint-enable */
  },
  methods: {
    formatAmount,
    async fetchList(params = {}) {
      this.loading = true;
      await this.$store.dispatch('workers-board/fetchList', {
        params,
        noPrepayment: this.noPrepayment,
      });
      this.loading = false;
    },
    getExpenses(transactions) {
      if (!transactions || !transactions.length) return null;

      const expenses = transactions.filter((item) => !item.is_number_positive);
      const list = expenses.map((item) => {
        const { type, name, amount, comment } = item; // eslint-disable-line
        const typeData = this.expensesTypes.find(
          ({ key }) => Number(key) === type,
        );

        const transactionName = type === 29 ? name : typeData.value;
        let str = `${transactionName}: ${formatAmount(amount)} `;
        str += comment ? `"${comment}" <br>` : '<br>';

        return str;
      });

      return list.join('');
    },
    async deleteItem(id) {
      this.deletingIds.push(id);
      const { error } = await this.$store.dispatch(
        'workers-board/deleteItem',
        id,
      );

      if (!error) {
        this.fetchList({
          ...this.filters,
          dates: this.dates,
          page: this.currentPage,
        });
      }

      this.deletingIds = this.deletingIds.filter((item) => item !== id);
      this.proccessResponse({ error, message: this.$t('common.saved') });
    },
    async restoreItem(id) {
      this.restoreIds.push(id);
      const { error } = await this.$store.dispatch(
        'workers-board/restoreItem',
        id,
      );

      if (!error) {
        this.fetchList({
          ...this.filters,
          dates: this.dates,
          page: this.currentPage,
        });
      }

      this.restoreIds = this.restoreIds.filter((item) => item !== id);
      this.proccessResponse({ error, message: this.$t('common.saved') });
    },
    proccessResponse({ message, error }) {
      const snack = {
        value: true,
        color: 'success',
        message,
      };

      if (error) {
        snack.message = error;
        snack.color = 'error';
      }

      this.snack = snack;
      this.sending = false;
    },
    async setRating(data, currentStatus) {
      this.updateItem(data);
      if (Number(data.car_status) === 5 && Number(currentStatus) === 1) {
        this.driverId = Number(data.driver_id);
        this.ratingDialog = true;
      }
    },
    async updateItem(data) {
      this.itemsUpdating.push(data.id);
      const formData = {
        car_status: data.car_status,
        driver_id: data.driver_id,
      };

      if (data.transactions) {
        formData.transactions = data.transactions;
      }

      if (data.explanation) {
        formData.explanation = data.explanation;
      }

      const response = await this.$store.dispatch('workers-board/updateItem', {
        id: data.id,
        formData,
      });

      await this.fetchList({ ...this.filters, dates: this.dates, page: 1 });

      this.itemsUpdating = this.itemsUpdating.filter((id) => id !== data.id);
      this.proccessResponse(response);

      this.showUpdated(data.id);
    },
    async onItemUpdated({ res, id }) {
      await this.fetchList({
        ...this.filters,
        dates: this.dates,
        page: this.currentPage,
      });

      this.proccessResponse(res);
      this.showUpdated(id);
      this.incomeEdit.value = false;
      this.debtEdit.value = false;
      this.expenseEdit.value = false;
    },
    allowedDates(value) {
      const [from, to] = this.dates;

      if (!from) return true;
      if (to) return true;

      const firstDate = new Date(from);
      const nextDate = new Date(value);

      return nextDate >= firstDate;
    },
    changeDate(val) {
      if (val.length === 2) {
        this.$refs.menuDate.save(this.dates);
      }
    },
    getDriver(item) {
      return item.driver ? item.driver : { user: {} };
    },
    isHidden(key) {
      return this.hiddenColumns.includes(key);
    },
    showUpdated(itemId) {
      this.itemsUpdated.push(itemId);
      setTimeout(() => {
        this.itemsUpdated = this.itemsUpdated.filter((id) => id !== itemId);
      }, 2500);
    },
    checkIsTransactionEditable(amount, item) {
      const isEditable = item.driver_id && item.car_status;
      return amount || isEditable;
    },
    getStatusColor(statusId) {
      switch (statusId) {
        case 1:
          return 'green lighten-4';
        case 2:
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 12:
          return 'white';
        case 5:
          return 'yellow lighten-4';
        case 8:
          return 'blue lighten-4';
        case 9:
        case 11:
          return 'orange lighten-4';
        case 13:
          return 'purple lighten-4';
        default:
          return 'red lighten-4';
      }
    },
    getPrepaymentColor(item) {
      const prepayment = Number(item.income.prepayment.amount) || 0;
      const rentPrice = Number(item.car.rentDayPrice);

      return rentPrice <= prepayment ? 'green lighten-4' : 'red lighten-4';
    },
    getStatusName(statusId, qtyDays) {
      const status = this.carStatuses.find(({ id }) => Number(id) === statusId);
      return status ? status.name + ' (' + qtyDays + ')' : '-';
    },
    isExpenseDisabled(item) {
      /* eslint-disable */
      return (
        !item.car_status ||
        !this.$can('workdesk_edit_cash') ||
        Boolean(this.filters.payment_type)
      );
      /* eslint-enable */
    },
  },
  async created() {
    const hiddenColumns = localStorage.getItem('workers-board-hidden-columns');
    this.hiddenColumns = hiddenColumns ? JSON.parse(hiddenColumns) : [];

    this.dataLoading = true;

    await Promise.all([
      this.$store.dispatch('workers-board/fetchTypes'),
      this.$store.dispatch('workers-board/fetchTypes', true),
      this.$store.dispatch('workers-board/fetchDialogProps'),
    ]);

    this.dataLoading = false;

    this.dates = [this.today, this.today];
  },
  mounted() {
    const table = this.$refs['workers-table'];
    this.tableHeight = calcTableHeight(table.$el);
  },
};
</script>

<style lang="scss">
.workers-board {
  &__filters {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      max-width: 200px;
      width: 100%;
      margin-right: 25px;

      // &.park {
      //   .v-select__selections {
      //     overflow-y: scroll;
      //     max-height: 32px;
      //     font-size: 14px;
      //   }
      // }
    }

    &-perPage {
      max-width: 100px;
      margin-left: auto;
    }
  }

  &__totals {
    position: sticky;
    bottom: 0;
    font-weight: 700;
  }

  .v-data-table-header {
    tr:first-child th {
      height: 30px !important;
      font-weight: 600 !important;
      text-align: center !important;

      &.section {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
      }
    }

    th {
      white-space: nowrap;
      height: 35px !important;

      &.section {
        background-color: lighten(#424242, 10%) !important;
      }
    }

    tr {
      transition: 0.3s !important;
    }
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .driver-link {
    font-weight: 600 !important;
    color: #424242;

    &:hover {
      text-decoration: none;
    }
  }

  .v-pagination {
    button {
      box-shadow: none !important;
    }
  }

  .nowrap {
    white-space: nowrap;
  }

  .text-edit-btn {
    text-decoration: underline;
    font-weight: 500;
    color: #464646;
    cursor: pointer;

    &:not(.disabled):hover {
      text-decoration: none;
    }

    &.disabled {
      font-weight: normal;
      pointer-events: none;
      cursor: auto;
    }
  }
}

.confirm-title {
  width: 100%;
  text-align: center;
  font-size: 14;
}

.search-wrapper {
  .search {
    margin-right: -12px;
    margin-bottom: -12px;
    max-width: 560px;
    width: 100%;

    @media (max-width: 480px) {
      margin-right: 0px;
      margin-bottom: -12px;
      max-width: 100%;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;

    .search {
      width: 100%;
    }
  }
}
.edit-btn {
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.3;
  text-decoration: none;

  &[disabled] {
    font-weight: normal;
  }

  &:not([disabled]):hover {
    opacity: 0.7;
  }
}
.date {
  max-width: 250px;
}
.date-td {
  width: 80px;
}
.v-btn.v-btn--disabled.v-btn--text {
  color: rgba(0, 0, 0, 0.5) !important;
}
.v-date-picker-title__date {
  font-size: 18px;
}
.v-btn.v-size--small {
  min-width: 20px !important;
}
.disabled-row {
  opacity: 0.5;
  pointer-events: none;
}
.updated-row {
  background-color: rgba(255, 240, 101, 0.4) !important;
}
.v-btn--disabled.v-btn--text {
  text-decoration: none !important;
}
</style>
